import React, {useEffect, useState} from "react";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";
import moment from "moment";
import SubCompanyInput from "../../createDeliveryRequest/deliveryRequestForm/pickupInformation/subCompanyInput/SubCompanyInput";
import locale from "antd/es/date-picker/locale/tr_TR";
import {DatePicker, Empty, Table, Tooltip} from "antd";
import {useHistory} from "react-router-dom/cjs/react-router-dom.min";
import {CloseCircleOutlined, DownloadOutlined, InfoCircleOutlined} from "@ant-design/icons";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";
import {b64DecodeToUrl} from "../../../utils/helpers";
import {EmptyMessage} from "../../_defaultComponents/EmptyMessage/EmptyMessage";

export const CariListDetail = ({subCompanyId}) => {
    const [pageParam, setPageParam] = useState(1);
    const defaultDateRange = [moment().subtract(30, "days"), moment()];
    const [selectedDateRange, setSelectedDateRange] = useState(defaultDateRange);
    const stores = useStore();
    const history = useHistory();
    const [loadingExcelData, setLoadingExcelData] = useState(false);
    const [selectedSubCompanyId, setSelectedSubCompanyId] = useState(null);
    const [documentId, setDocumentId] = useState(null);

    const [cariLogsLoading, cariLogs, _, __, refetch] = useFetch({
        defaultDataValue: [],
        fetchFn: () =>
            stores.companyStore.getCompanyCariLogs({
                ...(selectedSubCompanyId && {
                    subCompanyId: selectedSubCompanyId === "all" ? undefined : selectedSubCompanyId
                }),
                limit: 10,
                page: pageParam,
                startDate:
                    Array.isArray(selectedDateRange) &&
                    selectedDateRange.length === 2 &&
                    selectedDateRange[0] &&
                    selectedDateRange[1]
                        ? moment(selectedDateRange[0]).format("YYYY-MM-DD")
                        : undefined,
                endDate:
                    Array.isArray(selectedDateRange) &&
                    selectedDateRange.length === 2 &&
                    selectedDateRange[0] &&
                    selectedDateRange[1]
                        ? moment(selectedDateRange[1]).format("YYYY-MM-DD")
                        : undefined,
                excel: false
            }),
        initialCall: false,
        showLoading: true,
        dependencies: [selectedSubCompanyId, pageParam, selectedDateRange]
    });

    const getExcelTemplateData = async () => {
        setLoadingExcelData(true);
        try {
            const response = await stores.companyStore.getCompanyCariLogs({
                excel: true
            });
            console.log(response?.data?.data);
            const base64Data = response?.data?.data;
            const blobUrl = await b64DecodeToUrl(base64Data);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.setAttribute("download", "cari_kayit_detaylar.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.log("error", error);
        } finally {
            setLoadingExcelData(false);
        }
    };

    const [] = useFetch({
        defaultDataValue: null,
        fetchFn: async () => {
            const response = await stores.companyStore.downloadInvoice({
                documentId
            });
            const url = window.URL.createObjectURL(response);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "invoice.pdf");
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            return response;
        },
        initialCall: false,
        showLoading: true,
        dependencies: [documentId]
    });

    useEffect(() => {
        setSelectedSubCompanyId(subCompanyId);
    }, []);

    const handleDateChange = value => {
        setPageParam(1);
        if (!value || value.length === 0) {
            setSelectedDateRange([]);
        } else {
            setSelectedDateRange(value);
        }
    };

    return (
        <div style={{width: "100%"}}>
            <span style={styles.header}>Cari Kayıt Detayı</span>
            <div style={styles.headerContainer}>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10
                    }}
                >
                    <div
                        style={{
                            flexDirection: "column",
                            display: "flex",
                            minWidth: 200,
                            gap: 5,
                            marginBottom: "-20px"
                        }}
                    >
                        <SubCompanyInput
                            onChange={value => {
                                setSelectedSubCompanyId(value);

                                let path;

                                if (value) {
                                    path = `/credit-logs/cari-list/${value}`;
                                    history.push(path);
                                }
                            }}
                            initialCall={true}
                            allowClear={true}
                            disabled={false}
                            showAllOption={true}
                            value={selectedSubCompanyId}
                        />
                    </div>
                </div>
                <div style={styles.dateRangeContainer}>
                    <span>
                        Tarih{" "}
                        <Tooltip title="Son 30 günün verisi gösterilmektedir.">
                            <InfoCircleOutlined />
                        </Tooltip>
                    </span>
                    <DatePicker.RangePicker
                        placeholder={["Başlangıç Tarihi", "Bitiş Tarihi"]}
                        onChange={handleDateChange}
                        value={
                            selectedDateRange && selectedDateRange.length === 2
                                ? selectedDateRange
                                : undefined
                        }
                        locale={locale}
                        allowClear
                    />
                </div>
                <div style={{marginTop: "20px"}}>
                    <CustomButton
                        type="primary"
                        data-testid="exportWithExcelButton"
                        onClick={async () => {
                            setLoadingExcelData(true);
                            await getExcelTemplateData();
                        }}
                        loading={loadingExcelData}
                        icon={<DownloadOutlined />}
                    >
                        Excel Çıktısı İndir
                    </CustomButton>
                </div>
            </div>

            <Table
                rowKey={(_, index) => index.toString()}
                dataSource={cariLogs?.data?.rows}
                loading={cariLogsLoading}
                scroll={{x: "max-content"}}
                locale={{
                    emptyText: <EmptyMessage />
                }}
                pagination={{
                    total: cariLogs?.data?.dataCount,
                    current: pageParam,
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                    onChange: page => {
                        setPageParam(page);
                    }
                }}
            >
                <Table.Column title="İşlem Id" dataIndex="transactionId" key="transactionId" />
                <Table.Column
                    title="Alt Firma Id"
                    dataIndex="subCompanyId"
                    key="subCompanyId"
                    render={subCompanyId => (
                        <span>{subCompanyId === null ? "-" : subCompanyId}</span>
                    )}
                />
                <Table.Column title="Cari Kodu" dataIndex="cariCode" key="cariCode" />

                <Table.Column
                    title="Fatura Id"
                    dataIndex="invoiceId"
                    key="invoiceId"
                    render={invoiceId => (
                        <div>
                            {invoiceId === null ? (
                                "-"
                            ) : (
                                <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                                    {invoiceId}
                                    <CustomButton
                                        onClick={() => {
                                            setDocumentId(invoiceId);
                                        }}
                                    >
                                        <DownloadOutlined />
                                    </CustomButton>
                                </div>
                            )}
                        </div>
                    )}
                />
                <Table.Column
                    title="İşlem Türü"
                    dataIndex="type"
                    key="type"
                    render={type => <div>{type === 1 ? "Alacak" : "Borç"}</div>}
                />
                <Table.Column
                    title="Ücret Miktarı"
                    dataIndex="amount"
                    key="amount"
                    render={amount => <span>{parseFloat(amount).toFixed(2) + " TL"}</span>}
                />
                <Table.Column
                    title="Oluşturulma Tarihi"
                    dataIndex="createdAt"
                    key="createdAt"
                    render={createdAt => <span>{moment(createdAt).format("ll")}</span>}
                />
                <Table.Column
                    title="Güncelleme Tarihi"
                    dataIndex="updatedAt"
                    key="updatedAt"
                    render={updatedAt => <span>{moment(updatedAt).format("ll")}</span>}
                />
                <Table.Column
                    title="Hatalı Kayıt"
                    dataIndex="hasError"
                    key="hasError"
                    render={hasError => (
                        <span>{hasError === true ? <CloseCircleOutlined /> : ""}</span>
                    )}
                />
            </Table>
        </div>
    );
};

const styles = {
    headerContainer: {
        gap: 10,
        paddingBottom: 20,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center"
    },
    header: {
        fontSize: 20,
        fontWeight: "bold",
        width: "100%",
        paddingBottom: 16
    },
    dateRangeContainer: {
        flexDirection: "column",
        display: "flex",
        alignItems: "flex-start",
        margin: "30px 0",
        gap: 5
    }
};
